import type { ReactNode } from 'react';

export interface CardProps {
  title?: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
  /** 紧凑内边距（列表项里嵌卡片时用） */
  tight?: boolean;
  id?: string;
}

export function Card({ title, subtitle, actions, children, className, tight = false, id }: CardProps) {
  const classes = ['card', tight ? 'tight' : '', className ?? ''].filter((item) => item.length > 0).join(' ');
  const hasHead = title !== undefined || subtitle !== undefined || actions !== undefined;
  return (
    <section className={classes} id={id}>
      {hasHead ? (
        <header className="card-head">
          <div className="grow">
            {title !== undefined ? <h3 className="card-title">{title}</h3> : null}
            {subtitle !== undefined ? <p className="card-sub">{subtitle}</p> : null}
          </div>
          {actions !== undefined ? <div className="card-actions">{actions}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  );
}